export interface Investor {
  name: string;
  logo: string | null;
  url?: string;
  subtitle?: string;
}

export const images = {
  // Logo assets
  logo: {
    main: "/assets/logo/logo.png",
    footer: "/assets/logo/footer-logo.png",
    text: "/assets/logo-text.png",
  },

  // Landing page assets
  landing: {
    whatsSpicenet: {
      quest: "/assets/landing/whats-spicenet-1.png",
      game: "/assets/landing/whats-spicenet-2.png",
      leaderboard: "/assets/landing/whats-spicenet-3.png",
    },
    video: {
      desktop: "/assets/landing/video-desktop.png",
      mobile: "/assets/landing/video-mobile.png",
    },
  },

  // Feature icons for homepage (What's Spicenet section)
  features: {
    quest: "/assets/landing/whats-spicenet-1.png",
    game: "/assets/landing/whats-spicenet-2.png",
    leaderboard: "/assets/landing/whats-spicenet-3.png",
  },

  // Pattern/Background images (placeholder - will be replaced with actual assets)
  patterns: {
    checkerboard: "/assets/logo/logo.png", // Placeholder
  },

  // Hero images (placeholder - will be replaced with actual assets)
  hero: {
    desktop: "/assets/landing/video-desktop.png", // Placeholder
    mobile: "/assets/landing/video-mobile.png", // Placeholder
    lottie: "/assets/landing/hero-json.json",
  },

  // Social icons (placeholder - will be replaced with actual assets)
  social: {
    x: "/assets/logo/logo.png", // Placeholder
    telegram: "/assets/logo/logo.png", // Placeholder
    discord: "/assets/logo/logo.png", // Placeholder
    github: "/assets/logo/logo.png", // Placeholder
  },

  // Quest related (placeholder - will be replaced with actual assets)
  quests: {
    banner: "/assets/landing/blog-1.png", // Placeholder
    defaultCard: "/assets/landing/blog-1.png", // Placeholder
  },

  // Game assets (placeholder - will be replaced with actual assets)
  game: {
    preview: "/assets/landing/video-desktop.png", // Placeholder
    board: "/assets/landing/video-desktop.png", // Placeholder
  },

  // User avatars (placeholder - will be replaced with actual assets)
  avatars: {
    default: "/assets/logo/logo.png", // Placeholder
  },

  // Quest banner (used in quest modal)
  questsBanner: "/assets/landing/blog-1.png", // Placeholder

  // Founder video
  founder: {
    thumbnailDesktop: "/assets/landing/video-desktop.png",
    thumbnailMobile: "/assets/landing/video-mobile.png",
    videoUrl: "https://youtube.com/watch?v=T6U9m8HcDKk",
    youtubeVideoId: "T6U9m8HcDKk",
  },

  // Investor logos with details
  investors: [
    {
      name: "Hack VC",
      logo: "/assets/investors/hackvc.svg",
      url: "https://hack.vc",
    },
    {
      name: "Magnus Capital",
      logo: "/assets/investors/magnuscapital.svg",
      url: "https://www.magnuscapital.com/",
    },
    {
      name: "TPC Ventures",
      logo: "/assets/investors/tpcventures.svg",
      url: "https://www.tpc.ventures/",
    },
    {
      name: "Dora Ventures",
      logo: "/assets/investors/doraventures.svg",
      url: "https://dorahacks.io",
    },
    {
      name: "P-OPS",
      logo: "/assets/investors/pops.svg",
      url: "https://pops.one/",
    },
    {
      name: "Public Works",
      logo: "/assets/investors/publicworks.svg",
      url: "https://www.publicworks.fm/",
    },
    // {
    //   name: "Wagmi Ventures",
    //   logo: "/assets/investors/wagmiventures.svg",
    //   url: "https://www.wagmiventures.io/",
    // },
    // {
    //   name: "The Rollup",
    //   logo: "/assets/investors/rollup.svg",
    //   url: "https://therollup.co/",
    // },
    {
      name: "Babylon",
      logo: "/assets/investors/babylon.svg",
      url: "https://babylonlabs.io/",
    },
    {
      name: "Tea Club",
      subtitle: "Echo Group",
      logo: null,
    },
    {
      name: "Native Crypto",
      subtitle: "Echo Group",
      logo: null,
    },
    {
      name: "Celestine Sloths",
      subtitle: "Echo Group",
      logo: null,
    },
  ] as Investor[],

  // Blog posts
  blog: [
    {
      title: "Introducing Spice Flow",
      image: "/assets/landing/blog-3.png",
      url: "https://spicenet.io/blogs/spice-flow",
      author: "Spicenet",
      publishDate: "10 Sept 2025",
      readTime: "5 MIN READ",
    },
    {
      title: "Spicenet: The Brokerage Network for DeFi",
      image: "/assets/landing/blog-1.png",
      url: "https://spicenet.io/blogs/spicenet-the-brokerage-network-for-defi",
      author: "Spicenet",
      publishDate: "27 Aug 2025",
      readTime: "4 MIN READ",
    },
    {
      title: "Spicenet's Roadmap: The Path to Better Financial Outcomes in DeFi",
      image: "/assets/landing/blog-2.png",
      url: "https://spicenet.io/blogs/spicenet-roadmap",
      author: "Spicenet",
      publishDate: "03 Sept 2025",
      readTime: "4 MIN READ",
    },
  ],

  // Stories (YouTube Shorts)
  stories: [
    {
      id: "1",
      title: "Spicenet Architecture",
      thumbnail: "/assets/landing/story-1.png",
      youtubeVideoId: "dQw4w9WgXcQ",
    },
    {
      id: "2",
      title: "Global DeFi Network",
      thumbnail: "/assets/landing/story-2.png",
      youtubeVideoId: "dQw4w9WgXcQ",
    },
    {
      id: "3",
      title: "Spice Flow Demo",
      thumbnail: "/assets/landing/story-3.png",
      youtubeVideoId: "dQw4w9WgXcQ",
    },
    {
      id: "4",
      title: "Community Spotlight",
      thumbnail: "/assets/landing/story-4.png",
      youtubeVideoId: "dQw4w9WgXcQ",
    },
    {
      id: "5",
      title: "Brokerage Network",
      thumbnail: "/assets/landing/story-5.png",
      youtubeVideoId: "dQw4w9WgXcQ",
    },
  ],
};
